export enum ERozcestnikOptions {
    NOVY = 'PRID',
    ZMENA = 'ZMEN',
    ZRUSIT = 'ZRUS',
    REGISTRATION = 'REGI'
}
